// extracted by mini-css-extract-plugin
module.exports = {"gameCommentary":"GameCommentary_gameCommentary__1WH7C","winnerName":"GameCommentary_winnerName__324jQ","mediaLink":"GameCommentary_mediaLink__2AY5T"};